import { useState, useCallback } from 'react';
import Header from 'components/ui/Header';
import Sidebar from 'components/ui/Sidebar';
import CommandPalette from 'components/ui/CommandPalette';
import PageHeader from 'components/ui/PageHeader';
import { useGetRenewalSummaryQuery } from 'redux/features/employeeBondApi';
import BoardFilters from './components/BoardFilters';
import SummaryCards from './components/SummaryCards';
import RenewalBoard from './components/RenewalBoard';
import BondDetailModal from './components/BondDetailModal';
import RenewBondModal from './components/RenewBondModal';

const EmployeeBonds = () => {
  const [filters, setFilters] = useState({
    search: '',
    departmentId: 'all',
    status: 'all',
    daysUntilExpiry: 'all',
  });

  const [detailBond, setDetailBond] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [renewBond, setRenewBond] = useState(null);
  const [isRenewModalOpen, setIsRenewModalOpen] = useState(false);

  const {
    data: summaryData,
    isLoading: isSummaryLoading,
    refetch: refetchSummary,
  } = useGetRenewalSummaryQuery();

  const handleCardClick = useCallback((bond) => {
    setDetailBond(bond);
    setIsDetailModalOpen(true);
  }, []);

  const handleCloseDetailModal = useCallback(() => {
    setDetailBond(null);
    setIsDetailModalOpen(false);
  }, []);

  const handleRenewFromDetail = useCallback((bond) => {
    setIsDetailModalOpen(false);
    setRenewBond(bond);
    setIsRenewModalOpen(true);
  }, []);

  const handleCloseRenewModal = useCallback(() => {
    setRenewBond(null);
    setIsRenewModalOpen(false);
  }, []);

  const handleRefresh = useCallback(() => {
    refetchSummary();
  }, [refetchSummary]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-background to-secondary-50">
      <Header />
      <Sidebar />
      <CommandPalette />

      <main className="ml-60 mt-16 p-6 flex flex-col h-[calc(100vh-4rem)]">
        <PageHeader
          title="Bond Management"
          description="Manage and track employee bond renewals across the organization"
        />

        <BoardFilters filters={filters} onFiltersChange={setFilters} onRefresh={handleRefresh} />

        <SummaryCards summary={summaryData} isLoading={isSummaryLoading} />

        <div className="flex-1 min-h-0">
          <RenewalBoard
            filters={filters}
            onCardClick={handleCardClick}
            onOpenRenewModal={handleRenewFromDetail}
          />
        </div>
      </main>

      <BondDetailModal
        isOpen={isDetailModalOpen}
        onClose={handleCloseDetailModal}
        bond={detailBond}
        onRenew={handleRenewFromDetail}
      />

      <RenewBondModal isOpen={isRenewModalOpen} onClose={handleCloseRenewModal} bond={renewBond} />
    </div>
  );
};

export default EmployeeBonds;
